/**
 * Who sees what of the navigation tree (index.js): the sidebar (AppMenuItem), the command palette and the Android
 * app's tabs and "More" page all ask here, so none of them offers a page another would hide.
 */

/** Whether the user may open an entry: a super user always, anyone else with all its requiredPermissions. */
export function canOpen(user, item) {
    if (!user || user.is_super_user || !item.requiredPermissions) return true
    return item.requiredPermissions.every((permission) => user.routePermissions?.includes(permission))
}

/**
 * The pages of a tree the user may open, in order, as { label, icon, target, trail }: trail is the labels of the
 * folders above it, icon the entry's own or its nearest folder's.
 */
export function navPages(items, user, trail = [], icon = null) {
    const pages = []
    for (const item of items || []) {
        if (item.separator || !canOpen(user, item)) continue
        const inheritedIcon = item.icon || icon
        if (item.items?.length) {
            pages.push(...navPages(item.items, user, [...trail, item.label], inheritedIcon))
        } else if (item.target) {
            pages.push({ label: item.label, icon: inheritedIcon, target: item.target, trail })
        }
    }
    return pages
}

/** Whether the user may open the page a route name leads to: as the tree says, or yes when it isn't in the tree. */
export function canOpenTarget(items, user, target) {
    let found = null
    const walk = (list, chain) => {
        for (const item of list || []) {
            if (found) return
            if (item.items?.length) walk(item.items, [...chain, item])
            else if (item.target === target) found = [...chain, item]
        }
    }
    walk(items, [])
    return !found || found.every((item) => canOpen(user, item))
}
